import apiClient from "./client";

export async function fetchSettings(id) {
  return apiClient.get("/settings").then((res) => res.data);
}

export async function updateSettings(payload) {
  const { data } = await apiClient.put("/api/settings", payload);
  return data;
}
